module.exports = __webpack_public_path__ + "media/assets/images/shopping/brand-173bea87e55643feae13b424423fccfd.svg";